// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Tfov","dragIcon":"Choice_dragIcon__2bxo3","left":"Choice_left__1tdPi","input":"Choice_input__1eFuX"};